module.exports = __webpack_public_path__ + "img/email-success.4be5e74d.svg";